import React from 'react'
import './MessageBox.css'

const MessageBox = (props) => (
    <article className={`MessageBox-Container ${props.className ? props.className : ""}`}>
        <h2 className="MessageBox-Title">{props.title}</h2>
        <div className="MessageBox-Content-Wrapper">
            { props.children }
        </div>
    </article>
)

export default MessageBox


// WEBPACK FOOTER //
// ./src/components/messagebox/MessageBox.js